import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { SignupAccountVerificationContextImport } from "../../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";

const SignupPersonalLogoUploadButtons = (props: {
  type?: number | undefined;
}) => {
  const { uploadLogoAPI } = SignupAccountVerificationContextImport();

  return (
    <ButtonSingle
      handleClick={() => uploadLogoAPI()}
      width={300}
      processing={false}
    >
      {AppTranslation.text("submit")}
    </ButtonSingle>
  );
};

export default SignupPersonalLogoUploadButtons;
